// extracted by mini-css-extract-plugin
export default {"loadingScreen":"AuthGate_loadingScreen__pV2aj","title":"AuthGate_title__FAWEn","message":"AuthGate_message__WDujU"};